import React from "react";
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import './SomosVolteon.css';

const PuntosVenta = () => {
    return (
        <div>
            <Header></Header>
            <div className="volteon-container">
                <div className="volteon-content">
                    <h1>Puntos de Venta</h1>
                    <p>
                        Volteon Electronics cuenta con tres puntos de venta actualmente, ubicados en las
                        sedes de Cartago y San Carlos del Instituto Tecnológico de Costa Rica. Estos
                        corresponden a las oficinas de las Asociaciones de Estudiantes de las carreras de
                        Ingeniería Electrónica en Cartago (AESETEC) y San Carlos (ADESC), así como la
                        de Ingeniería en Computadores en Cartago (ASEIC).

                    </p>
                    <p>
                        Estas Asociaciones funcionan mediante un convenio que busca fomentar la
                        accesibilidad a los componentes electrónicos por parte de los estudiantes, por lo que
                        sus miembros no son empleados de Volteon Electronics. Además, los horarios de
                        apertura y disponibilidad de estos puntos de venta están sujetos a la coordinación de
                        dichas Asociaciones, por lo que Volteon no se hace responsable por su
                        incumplimiento.

                    </p>
                    
                    <p>
                        En nuestros puntos de venta se puede adquirir directamente componentes
                        electrónicos, ya sea mediante efectivo o SinpeMóvil. Además, funcionan como punto
                        de recolección, en su respectivo horario de apertura, para los pedidos realizados
                        directamente desde el sitio web.

                    </p>
                   
                </div>
            </div>

            <Footer></Footer>
        </div>

    );
};

export default PuntosVenta;